export function generateNameCSVFile(label, from, to) {
    const fromDate = new Date(from)
    const toDate = to ? new Date(to) : new Date()

    const dates = {
        from: `${fromDate.toLocaleDateString('en-US')} ${fromDate.toLocaleTimeString('en-US')}`,
        to: `${toDate.toLocaleDateString('en-US')} ${toDate.toLocaleTimeString('en-US')}`,
    }
    return `${label} (${dates.from} - ${dates.to}).csv`
}
